import { render, staticRenderFns } from "./platformSide.vue?vue&type=template&id=070d04b0&scoped=true&"
import script from "./platformSide.vue?vue&type=script&lang=js&"
export * from "./platformSide.vue?vue&type=script&lang=js&"
import style0 from "./platformSide.vue?vue&type=style&index=0&id=070d04b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070d04b0",
  null
  
)

export default component.exports